app.service('vies', function (topModal, broker) {

	function init({ $box, $vatNumber, $button, $country, $taxIdSelector = null, nipEuValidate, validatedVatUeNumbers = [], onVatUeValidationUpdated }) {
		let vatNumber, country;

		if ($button.length && $vatNumber.length && $country.length) {
			$button.on('click', function () {
				if (check()) {
					load();
				}
			});
			if ($taxIdSelector) {
				$taxIdSelector.on('change', function () {
					if ($taxIdSelector.val() === 'VAT_UE' && $vatNumber.val().length > 0) {
						check();
					}
				});
			}
			$vatNumber.on('input', function () {
				check();
			});
			$country.on('change', function () {
				check();
			});
			function check(firstInit) {
				country = $country.val();
				let vatUeNumber = $vatNumber.val();

				let result = false;
				if (nipEuValidate && nipEuValidate[country]) {
					result = new RegExp(nipEuValidate[country], "g").test(vatUeNumber);

					if (country) {
						console.log(`reguła walidacji NIPEU dla ${country} = ${nipEuValidate[country]}`);
						$vatNumber.data('nip-rules', nipEuValidate[country])
						/*if ($nip.val().length) {
							$nip.closest('form').validate().element($nip);
						}*/
					} else {
						console.log('Brak reguły walidacyjnej dla kraju ' + country);
					}
				}
				vatNumber = vatUeNumber;
				if (!firstInit) {
					if (result) {
						$button.prop('disabled', false);
					} else {
						$button.prop('disabled', true);
					}
					$button.removeClass('hide');
					$vatNumber.removeClass('is-verified');
					$box.removeClass('is-failure').removeClass('is-success');

					if (validatedVatUeNumbers.some(entry => entry[country] && entry[country].includes(vatUeNumber))) {
						done(true);
					} else {
						onVatUeValidationUpdated();
					}

					return result;
				}
			}
			function done(result) {

				if (result) {
					$box.removeClass('is-failure').addClass('is-success');
					$button.addClass('hide');
					$vatNumber.addClass('is-verified');
				} else {
					$box.removeClass('is-success').addClass('is-failure');
				}

				broker.trigger('VIES_VERIFICATION_FINISHED', {success: result, vatUeNumber: vatNumber, countryCode: country});
			}
			function showError() {
				topModal.generate({
					cssClass: 'vies-loading-error',
					header: 'Brak pobierania danych z rejestru VIES',
					content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP.',
				});
			}
			function load() {
				topModal.generate({
					cssClass: 'regon-loading',
					close: false,
					content: 'Pobieramy dane firmy.<br/>Może to zająć chwilę',
				});
				$.ajax({
					url: `/check-vat.ltr?vatNumber=${vatNumber}&countryCode=${country}`,
					success: function (json) {
						if (json.status === 'VALID') {
							topModal.close();
							done(true);
						} else if (json.status === 'INVALID') {
							topModal.generate({
								cssClass: 'vies-loading-error',
								header: 'Błąd walidacji w rejestrze VIES',
								content: 'Podany numer VAT UE jest nieaktywny. Nie możemy wystawić faktury na nieaktywny numer VAT UE.',
							});
							done(false);
						} else if (json.status === 'ERROR') {
							topModal.generate({
								header: "Błąd walidacji w rejestrze VIES",
								content: "Nie udało się zweryfikować podanego numeru VAT UE.",
								cssClass: 'vies-loading-error',
							});
							done(false);
						}
					}, error: function () {
						showError();
					}
				});
			}
			check(true);
		}
	}
	return {
		init
	};
});